import { BaseColorKeys, PureColorKeys } from '../../../../theme';
import { CourseEnrolmentState, DiscountType } from '../../../../types/common';

export const getBillingChip = (state: string): {
  color: PureColorKeys | BaseColorKeys,
  label: string,
} => {
  if (state === CourseEnrolmentState.Active) {
    return {
      color: 'lightGreen' as PureColorKeys,
      label: 'Active',
    };
  }

  if (state === CourseEnrolmentState.OnTrial) {
    return {
      color: 'lightYellow' as PureColorKeys,
      label: 'On Trial',
    };
  }

  return {
    color: 'gray' as PureColorKeys,
    label: 'Discontinued',
  };
};

export const getDiscountValueLabel = (type: string, amount: number): string => {
  switch (type) {
    case DiscountType.Constant:
      return `$${amount} off every invoice.`;
    case DiscountType.OneOff:
      return `$${amount} off next invoice only.`;
    case DiscountType.Percentage:
      return `${amount}% off every invoice item.`;
    default:
      return '???';
  }
};

export const getDiscountStackableLabel = (stackable: boolean): string => {
  if (stackable) return 'Stackable.';
  return 'Non-stackable.';
};
